import { Component, EventEmitter, Input, Output, signal, WritableSignal } from '@angular/core';
import { CmsNavigationEntry, CmsNavigationNode } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';

export interface GgFooterNavNodeComponent {
  uid: string;
  navigationNode: CmsNavigationNode;
}

@Component({
  selector: 'app-gg-footer-nav-node',
  templateUrl: 'gg-footer-nav-node.component.html',
  styleUrls: ['gg-footer-nav-node.component.scss'],
  standalone: false,
})
export class GgFooterNavNodeComponent {
  data$: Observable<GgFooterNavNodeComponent> = this.componentData.data$;

  constructor(private componentData: CmsComponentData<GgFooterNavNodeComponent>) {}

  @Input() rowClass = 'row';
  @Output() accordionToggle = new EventEmitter<string>();

  trackByMethod(index: number, entry: CmsNavigationEntry): string | undefined {
    return entry.itemId;
  }

  accordionToggleClick(event: Event): void {
    const parentNode = (event.target as HTMLElement).parentNode as HTMLElement;
    parentNode.classList.toggle('show');
    event.stopPropagation();
  }
}
